import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import Logo from '../../../assets/InvoiceLogo.png'
import Sign from '../../../assets/VingaSignature.jpg'

const TenancyAgreement = forwardRef((props, ref) => {
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    aggrement: { day: "17", monthAndYear: "March, 2023" },

    partyB: {
      fullName: "Gopi krishnan",
      passportNumber: "777777",
      finNo: "44994",
    },
    form2: {
      partyA: {
        signature: "",
        Date: "24/03/2025",
      },
      partyB: {
        signature: "",
        Passport_Fin_No: "7777",
        phone_contact: "55372726",
        Date: "24/03/2025",
      },
    },
    checkoutForm: {
      name: "Gopi",
      Room_no: 103,
      contact_no: 90803814,
      party_A_noticeDate: "24/04/2025",
      party_B_noticeDate: "24/04/2025",
      moveOutDate: "24/05/2025",
      actualMoveOutDate: "25/05/2025",
      moveOutTime: "6:30pm",
      partyAggrement: {
        partyA: { signature: "", name: "vinga", date: "25/05/2025" },
        partyB: { signature: "", name: "vinga", date: "25/05/2025" },
      },
    },
  });

  useImperativeHandle(ref, () => ({
    generatePDFs,
  }));

  const formatDate = (timestamp) => {
    const date = new Date(Number(timestamp)); // convert timestamp to Date
  
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
  
    // Function to get day suffix
    const getDaySuffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    return `${day}${getDaySuffix(day)} ${month} ${year}`;
  };

  const generatePDFs = async () => {
      console.log('called contract')
    setIsGeneratingPDF(true);
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 0));

    // Create a single jsPDF instance
    const pdf = new jsPDF();

    // Component One - First Page
    const componentOne = document.getElementById("component-one");
    const canvasOne = await html2canvas(componentOne, {
      scale: 2,
      useCORS: true,
    });
    const imgDataOne = canvasOne.toDataURL("image/png");
    pdf.addImage(
      imgDataOne,
      "PNG",
      0,
      0,
      210,
      (canvasOne.height * 210) / canvasOne.width
    );
    pdf.addPage();

    // Component Two - Second Page
    const componentTwo = document.getElementById("component-two");
    const canvasTwo = await html2canvas(componentTwo, {
      scale: 2,
      useCORS: true,
    });
    const imgDataTwo = canvasTwo.toDataURL("image/png");
    pdf.addImage(
      imgDataTwo,
      "PNG",
      0,
      0,
      210,
      (canvasTwo.height * 210) / canvasTwo.width
    );
    pdf.addPage();

    // Component Three - Third Page
    const componentThree = document.getElementById("component-three");
    const canvasThree = await html2canvas(componentThree, {
      scale: 2,
      useCORS: true,
    });
    const imgDataThree = canvasThree.toDataURL("image/png");
    pdf.addImage(
      imgDataThree,
      "PNG",
      0,
      0,
      210,
      (canvasThree.height * 210) / canvasThree.width
    );
    pdf.addPage();

    // Component Four - Fourth Page
    const componentFour = document.getElementById("component-four");
    const canvasFour = await html2canvas(componentFour, {
      scale: 2,
      useCORS: true,
    });
    const imgDataFour = canvasFour.toDataURL("image/png");
    pdf.addImage(
      imgDataFour,
      "PNG",
      0,
      0,
      210,
      (canvasFour.height * 210) / canvasFour.width
    );
    pdf.addPage();

    // Component Five - Fifth Page (Signatures)
    const componentFive = document.getElementById("component-five");
    const canvasFive = await html2canvas(componentFive, {
      scale: 2,
      useCORS: true,
    });
    const imgDataFive = canvasFive.toDataURL("image/png");
    pdf.addImage(
      imgDataFive,
      "PNG",
      0,
      0,
      210,
      (canvasFive.height * 210) / canvasFive.width
    );
    // pdf.addPage();

    // Component Six - Sixth Page (Checkout Notice Form)
    // const componentSix = document.getElementById("component-six");
    // const canvasSix = await html2canvas(componentSix, {
    //   scale: 2,
    //   useCORS: true,
    // });
    // const imgDataSix = canvasSix.toDataURL("image/png");
    // pdf.addImage(
    //   imgDataSix,
    //   "PNG",
    //   0,
    //   0,
    //   210,
    //   (canvasSix.height * 210) / canvasSix.width
    // );

    pdf.save("Tenancy-Agreement.pdf");
    setIsGeneratingPDF(false);
    setLoading(false);
  };

    const signedDate = props?.allData?.tenancyAgreement?.signedDate;
    const formattedDate = signedDate ? formatDate(signedDate) : '';

  console.log(props)

  return (
    <div style={{ position: "absolute", left: "-9999px" }}>
        {/* Component One - First Page */}
        <div
          id="component-one"
          style={{
            width: "210mm",
            minHeight: "297mm",
            padding: "20mm",
            backgroundColor: "white",
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.5",
            fontSize: "12pt",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <div style={{ marginRight: "20px", marginTop: "20px" }}>
              <img
                src={Logo}
                alt="Company Logo"
                style={{
                  height: "80px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </div>

            <div style={{ textAlign: "center" }}>
              <h2 style={{ marginBottom: "5px", fontSize: "16pt" }}>
              SINGAPORE VINGA INTERNATIONAL PTE LTD
              </h2>
              <p style={{ margin: "3px 0", fontSize: "11pt" }}>
              Registration No.: 200516098N
              </p>
              <p style={{ margin: "3px 0", fontSize: "11pt" }}>
                Address: {props?.allData?.RoomsData?.selectedRoom?.location}
              </p>
            </div>
          </div>

          <div style={{ margin: "30px 0" }}>
            <h2
              style={{
                marginBottom: "10px",
                fontSize: "14pt",
                textDecoration: "underline",
                textAlign: "center",
              }}
            >
              TENANCY AGREEMENT
            </h2>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>
                THIS AGREEMENT is made on the{" "}
                <span style={{ fontWeight: "bold" }}>{formattedDate}</span>:
                </p>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <h3 style={{ marginBottom: "10px", fontSize: "12pt" }}>
              <span style={{ fontWeight: "bold" }}>PARTY A</span>{" "}
              <span style={{ fontWeight: 400 }}>("the Landlord/Licensor")</span>
            </h3>
            <p
              style={{ margin: "5px 0", fontSize: "11pt", fontWeight: "bold" }}
            >
              Singapore Vinga International Pte Ltd
            </p>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>Vinga Hall</p>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>
              Address: {props?.allData?.RoomsData?.selectedRoom?.location}
            </p>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>UEN : 200516098N</p>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <h3 style={{ marginBottom: "10px", fontSize: "12pt" }}>
              PARTY B{" "}
              <span
                style={{
                  fontWeight: 400,
                }}
              >
                ( "the Student")
              </span>
            </h3>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>
              Full Name: {props?.allData?.userData?.name}
            </p>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>
              Passport No.: {props?.allData?.PersonalData?.Details?.passport_no}
            </p>
            <p style={{ margin: "5px 0", fontSize: "11pt" }}>
              Fin No.: {props?.allData?.tenancyAgreement?.fin_no}
            </p>
          </div>

          <div>
            <h3
              style={{
                marginBottom: "10px",
                fontSize: "12pt",
                textAlign: "center",
                fontWeight : 700
              }}
            >
              AGREEMENT TERMS
            </h3>
            <p
              style={{
                margin: "5px 0",
                textAlign: "justify",
                fontSize: "11pt",
              }}
            >
              The Student will check-in to Vinga Hall, address: {props?.allData?.RoomsData?.selectedRoom?.location}, 
              both parties come into agreed terms as follows:
            </p>
          </div>
          <div style={{display : 'flex', justifyContent : 'flex-end', alignItems : 'end', height : '400px'}}>
            <p style={{color : 'gray'}}>1</p>
          </div>
        </div>

        <div
          id="component-two"
          style={{
            width: "210mm",
            minHeight: "297mm",
            padding: "20mm",
            backgroundColor: "white",
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.5",
            fontSize: "11pt",
          }}
        >
          <h3
            style={{
              marginBottom: "15px",
              fontSize: "12pt",
            }}
          >
            1. <span style={{textDecoration: "underline"}}>Party A (Landlord) responsibilities</span>
          </h3>
          <ol style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A allows the Student to stay in Vinga Hall address, and
              promises to monitor on the Student's activities during the stay.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A agrees to provide the Student, a room with bed, mattress,
              wardrobe, bookshelves and writing desk, to ensure the Student
              stays in a clean, comfortable and conducive environment.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A reserves the right to allocate and to change room for the
              Student anytime.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A offers free Wifi & LAN internet facilities inside the
              room.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A provides free air-con, electricity and water supply.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A provides free laundry services twice weekly.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A provides daily general room cleaning services and twice
              weekly specific cleaning.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will bring new student to get familiar with the living
              environment. If the Student is sick, Party A will take initiative
              to take care of the Student and to inform the Parents, or guardian
              in Singapore. If needed, assists to bring the Student to see
              doctor. All transport and doctor consulatation expenses will be
              borned by the Student.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will report to the Parents or guardian in Singapore daily,
              through Wechat group chat at around 10pm regarding the Student's
              status.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will promptly reply the Parents or guardian in Singapore
              any enquiry related to the Student's living condition or his/her
              status.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will manage cash allowance, if the Parents opted for the
              service, and will distribute the allowance weekly on time with the
              agreed sum.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will provide airticket advanced booking service free of
              charge.
            </li>
          </ol>
          <div style={{display : 'flex', justifyContent : 'flex-end', alignItems : 'end', height : '400px'}}>
            <p style={{color : 'gray'}}>2</p>
          </div>
        </div>

        <div
          id="component-three"
          style={{
            width: "210mm",
            minHeight: "297mm",
            padding: "20mm",
            backgroundColor: "white",
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.5",
            fontSize: "11pt",
          }}
        >
          <ol start="13" style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will provide the Student with counseling services on
              living overseas or education related matters. Facilitate the
              Student to successfully completed his/her study and to maintain a
              healthy lifestyle.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will provide local school transfer consultation service
              free of charge, and to give advice to the Student on overseas
              study matters.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A will also provide migration consultation service free of
              charge.
            </li>
          </ol>

          <h3
            style={{
              marginBottom: "15px",
              fontSize: "12pt",
              
            }}
          >
            2. <span style={{textDecoration: "underline"}}>Party B (Parents and/or Tenant/Student) responsibilities</span>
          </h3>
          <ol style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B agrees, within this agreement validity, while studying in
              Singapore, to stay in Vinga Hall.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B will have to follow the terms of this agreement, to pay
              the room rental fee and the room rental deposit on time.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B will have to declare the Student's health condition, any
              food allergy, drug allergy, as well as the treatment of these
              allergies.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B has to strictly adhere to Singapore law and regulations.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B has to follow school rules and Vinga Hall rules.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B must be punctual when attending school and returning to
              Vinga Hall. In case, if the Student is unable to return home from
              school on time, he/she must notice Hostel Management in advance,
              and to seek approval with a valid reason.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B has to obey all rules and regulations set by Vinga Hall
              Management, and to live harmoniously with other residents.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B is not allowed to create any disturbance to other
              residents, in particular, noise, within Vinga Hall. Party B must
              learn to be considerate to other residents.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B has to follow the assigned rest time, meal time and self
              study time.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B has to protect the property of Vinga Hall, Party B will
              have to compensate for any property being damaged.
            </li>
          </ol>
          <div style={{display : 'flex', justifyContent : 'flex-end', alignItems : 'end', height : '300px'}}>
            <p style={{color : 'gray'}}>3</p>
          </div>
        </div>

        {/* Component Four - Fourth Page */}
        <div
          id="component-four"
          style={{
            width: "210mm",
            minHeight: "297mm",
            padding: "20mm",
            backgroundColor: "white",
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.5",
            fontSize: "11pt",
          }}
        >
          <ol start="11" style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B should approach Vinga Hall Management for safe-keeping of
              cash or valuables, Vinga Hall Management will not be responsible
              for any loss.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B should avoid wastage of water and electricity. Aircon,
              lightings, computers and other electrical appliances must be
              turned off when the Student is not in the room.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B needs to purchase adequate medical insurance during the
              time studying in Singapore.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B is not allowed to bring or to consume any alcohol, tobacco
              or drug in Vinga Hall.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B is not allowed to cook inside the room, high voltage of
              electricity usage may lead to electric short curcuit. In such
              case, Party B will have to bear the consequences. Any personal
              electrical item to be placed in the room will be subject to Vinga
              Hall Management approval.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B must follow the rules of Vinga Hall, in terms of resting
              and sleeping time. In case, if the Student has to be back late
              with a valid reason, the Student must give advanced notice to
              Vinga Hall Management and the guardian in Singapore.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              If the Student is below the age of 18, he/she must return to Vinga
              Hall by 6pm, the latest.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B is not allowed to bring friends, schoolmates, to visit
              Vinga Hall at all times.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              If Party B committed any offence in school or in Singapore,
              causing deportation or student pass termination, This tenancy
              agreement will be immediately terminated, and there will be no
              refund at all from Party A, Moreover, Party B will have to pay
              back the unpaid rental amount.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party B will still have to pay for full rental when going away for
              holiday, tour trips or sleep-out within the contract period.
            </li>
          </ol>

          <h3
            style={{
              marginBottom: "15px",
              fontSize: "12pt",
              
            }}
          >
            3. <span style={{textDecoration: "underline"}}>Rental Payment & Deposit</span>
          </h3>
          <ol style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Rental payment should be an one-off settlement. For a 2-year
              agreement, it can be settled on a yearly basis. Total rental
              payment at
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Upon signing of agreement, Party B must pay a rental deposit,
              equivalent to 1-month rental charge, at
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              When this agreement expiring, the room condition will have to be
              the same as move-in condition, except fair wear and tear. In such
              case, full deposit will be refunded (without interest) to Party B.
              Whereby, if there is any property damaged in the room, Party B
              will have to compensate for the damage or loss, based on the price
              fixed in the signed checklist, and it will be deducted accordingly
              from the rental deposit. Vinga Hall Management reserves the right
              to pursue any additional compensation whereby the rental deposit
              is not sufficient to cover the total cost of damage or loss.
            </li>
          </ol>
          <div style={{display : 'flex', justifyContent : 'flex-end', alignItems : 'end', height : '140px'}}>
            <p style={{color : 'gray'}}>4</p>
          </div>
        </div>

        <div
          id="component-five"
          style={{
            width: "210mm",
            minHeight: "297mm",
            padding: "20mm",
            backgroundColor: "white",
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.5",
            fontSize: "11pt",
          }}
        >
          <ol start="4" style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              The rental deposit paid upon the signing of agreement will not be
              allowed to offset the monthly rental payment.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              If the rental payment is not settled by Party B on the due date, a
              penalty of 1% daily interest rate will be imposed on Party B,
              maximum cap at 10%. If the rental payment cannot be settled within
              10 days from the due date, Party A reserves the right to terminate
              the Agreement, at any time, without further notice.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              If Party B did not fulfil the signed agreement's full period of
              stay, Party A reserves the right not to return the paid rental
              amount to Party B, but Party A will refund the rental deposit to
              Party B, provided that no damage is found in the room.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Upon agreement expiration, if Party B decided not to renew the
              lease, Party B must fill up the Check-Out notice form (see
              attached) one month before the agreement expiry date, and submit
              to Vinga Hall Management. Failure to do so will result in the
              rental deposit not being refunded.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              One month before the agreement is expiring, Party B must give full
              1-month advanced notice, either to continue staying in Vinga Hall
              or to move out. Without notice given by Party B, the agreement
              will be automatically renew with the same duration as the previous
              agreement.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Party A reserves the right not to renew the agreement with Party B
              upon agreement expiration, on a case by case basis.
            </li>
          </ol>

          <h3
            style={{
              marginBottom: "15px",
              fontSize: "12pt",
              
            }}
          >
            4. <span style={{textDecoration: "underline"}}>Additional term & Amendment</span>
          </h3>
          <ol style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              Any supplement, change or amendment of this agreement, must be in
              written format, with both parties' signatures, in order to be
              effective.
            </li>
          </ol>

          <h3
            style={{
              marginBottom: "15px",
              fontSize: "12pt",
              
            }}
          >
            5. <span style={{textDecoration: "underline"}}>Commencement & Ceasation of agreement terms</span>
          </h3>
          <ol style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              This agreement will take effect on the day that both Party A and
              Party B signed and stamped on the agreement.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              This agreement has 2 original copies, both Party A and Party B
              keeps one copy each.
            </li>
            <li style={{ marginBottom: "8px", textAlign: "justify" }}>
              This agreement will consider ended, after both parties fulfilled
              their own obligations and responsibilities.
            </li>
          </ol>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "50px",
            }}
          >
            <div style={{ width: "48%" }}>
              <h4 style={{ marginBottom: "10px", fontSize: "11pt" }}>
                PARTY A : SINGAPORE VINGA INTERNATIONAL PTE LTD
              </h4>
              <p style={{ margin: "5px 0" }}>Party A Signature</p>
              <>
              <img
                src={data?.form2?.partyA?.signature || Sign}
                style={{
                  height: "50px",
                  margin: "10px auto",
                  borderBottom: "1px solid #000",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />
              </>
              <p style={{ margin: "5px 0" }}>UEN : 200516098N</p>
              <p style={{ margin: "5px 0" }}>Phone Contact : +6566776789</p>
              <p style={{ margin: "5px 0" }}>
                Date : {dayjs(props?.allData?.tenancyAgreement?.signedDate).format("DD/MM/YYYY")}
              </p>
            </div>
            <div style={{ width: "48%" }}>
              <h4 style={{ marginBottom: "10px", fontSize: "11pt" }}>
                PARTY B : {props?.allData?.userData?.name}
              </h4>
              <p style={{ margin: "5px 0" }}>Party B Signature</p>
              <img
                src={`${process.env.REACT_APP_FILE_PATH}${props.signatureImage}`}
                style={{
                  height: "50px",
                  margin: "10px auto",
                  borderBottom: "1px solid #000",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />
              <p style={{ margin: "5px 0" }}>
                Passport / Fin No : {props?.allData?.PersonalData?.Details?.passport_no}
              </p>
              <p style={{ margin: "5px 0" }}>
                Phone Contact :+{props?.allData?.userData?.phone}
              </p>
              <p style={{ margin: "5px 0" }}>
                Date : {dayjs(props?.allData?.tenancyAgreement?.signedDate).format("DD/MM/YYYY")}
              </p>
            </div>
            <div style={{display : 'flex', justifyContent : 'flex-end', alignItems : 'end', height : '210px'}}>
            <p style={{color : 'gray'}}>5</p>
          </div>
          </div>
          
        </div>

        <div
          id="component-six"
          style={{
            width: "210mm",
            minHeight: "297mm",
            padding: "25mm",
            backgroundColor: "white",
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            fontSize: "12pt",
          }}
        >
          {/* Title Section */}
          <h2
            style={{
              textAlign: "center",
              marginBottom: "30px",
              fontSize: "14pt",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            CHECK-OUT NOTICE FORM
          </h2>

          {/* Student Information */}
          <div
            style={{
              marginBottom: "25px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
            }}
          >
            <div>
              <p style={{ margin: "8px 0" }}>
                <strong>Name:</strong> {data?.checkoutForm?.name}
              </p>
            </div>
            <div>
              <p style={{ margin: "8px 0" }}>
                <strong>Room No:</strong> {data?.checkoutForm?.Room_no}
              </p>
            </div>
            <div>
              <p style={{ margin: "8px 0" }}>
                <strong>Contact No:</strong> {data?.checkoutForm?.contact_no}
              </p>
            </div>
          </div>

          {/* Notice Dates */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "25px",
            }}
          >
            <div>
              <p style={{ margin: "8px 0" }}>
                <strong>Party A Notice Date:</strong>{" "}
                {data?.checkoutForm?.party_A_noticeDate}
              </p>
            </div>
            <div>
              <p style={{ margin: "8px 0" }}>
                <strong>Party B Notice Date:</strong>{" "}
                {data?.checkoutForm?.party_B_noticeDate || "___________"}
              </p>
            </div>
          </div>

          {/* Move Out Details */}
          <div style={{ marginBottom: "25px" }}>
            <p style={{ margin: "8px 0" }}>
              <strong>
                Party A requires Party B to move out of Vinga Hall by:
              </strong>
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "15px",
                marginTop: "10px",
              }}
            >
              <div>
                <p style={{ margin: "8px 0" }}>
                  <strong>Date:</strong>{" "}
                  {data?.checkoutForm?.moveOutDate || "___________"}
                </p>
              </div>
              <div>
                <p style={{ margin: "8px 0" }}>
                  <strong>Party B actual move out Date:</strong>{" "}
                  {data?.checkoutForm?.actualMoveOutDate || "___________"}
                </p>
              </div>
              <div>
                <p style={{ margin: "8px 0" }}>
                  <strong>Time:</strong>{" "}
                  {data?.checkoutForm?.moveOutTime || "___________"}
                </p>
              </div>
            </div>
          </div>

          {/* Agreement Text */}
          <p
            style={{
              margin: "20px 0",
              textAlign: "center",
            }}
          >
            Both parties understand and agree to this notice as signed below:
          </p>

          {/* Signatures */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              marginTop: "50px",
            }}
          >
            {/* Party A Signature */}
            <div style={{ textAlign: "justify" }}>
              <p style={{ margin: "5px 0", fontWeight: "bold" }}>
                Party A Signature
              </p>
              <img
                src={
                  data?.checkoutForm?.partyAggrement?.partyA?.signature || Logo
                }
                style={{
                  height: "50px", // Adjust based on your signature image size
                  margin: "10px auto",
                  borderBottom: "1px solid #000", // Optional: visual line under signature
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />
              <div style={{ textAlign: "justify" }}>Vinga Hall </div>
              <p style={{ margin: "5px 0" }}>
                <strong>Name:</strong>
                {data?.checkoutForm?.partyAggrement?.partyA?.name ||
                  "___________"}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>Date:</strong>
                {data?.checkoutForm?.partyAggrement?.partyA?.date ||
                  "___________"}
              </p>
            </div>

            {/* Party B Signature */}
            <div
              style={{
                textAlign: "justify",
                maxWidth: "300px",
                margin: "0 auto",
              }}
            >
              <p style={{ margin: "5px 0", fontWeight: "bold" }}>
                Party B Signature
              </p>
              <img
                src={`${process.env.REACT_APP_FILE_PATH}${props.signatureImage}`}
                style={{
                  height: "50px",
                  margin: "10px auto",
                  borderBottom: "1px solid #000",

                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />

              <div style={{ display: "flex", margin: "5px 0" }}>
                <strong style={{ width: "60px", textAlign: "left" }}>
                  Name:
                </strong>
                <div
                  style={{
                    flex: 1,

                    textAlign: "left",
                    paddingLeft: "10px",
                  }}
                >
                  Gopi
                </div>
              </div>

              <div style={{ display: "flex", margin: "5px 0" }}>
                <strong style={{ width: "60px", textAlign: "left" }}>
                  Date:
                </strong>
                <div
                  style={{
                    flex: 1,

                    textAlign: "left",
                    paddingLeft: "10px",
                  }}
                >
                  24/05/24
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
})

export default TenancyAgreement